import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
//import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import zenscroll from "zenscroll";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  let introEl = document.getElementById("intro");
  if (typeof introEl != "undefined" && introEl != null) {
    introInit();
  }

  function introInit() {
    let articleContent = document.querySelector("article.inner");
    let logoDesktop = introEl.querySelector(".top_logo.desktop");
    let logoMobile = introEl.querySelector(".top_logo.mobile");
    let background = introEl.querySelector(".background");
    let textElements = introEl.querySelectorAll(".text-element");
    let cta = introEl.querySelector(".cta");
    let tl;

    let mobile = window.innerWidth <= 768;

    document.body.classList.add("with_intro");

    // pushing down the main content for animation
    gsap.set(articleContent, { y: 150 });

    let ctaTween = gsap.to(cta, {
      opacity: 1,
      duration: 0.3,
      delay: 1,
      ease: "power2.out",
    });

    introEl.addEventListener("click", function (e) {
      e.preventDefault();

      ctaTween.kill();

      tl = gsap.timeline({
        onComplete: function () {
          introEl.classList.add("finished");
          document.body.classList.remove("with_intro");
        },
      });

      tl.to(textElements, {
        opacity: 0,
        duration: 0.3,
      });
      tl.to(
        [logoDesktop, logoMobile],
        {
          top: mobile ? "30px" : "5px",
          left: mobile ? "50%" : "50%",
          width: mobile ? "108px" : "226px",
          duration: 1,
          ease: "power2.inOut",
        },
        ".5",
      );
      tl.to(
        background,
        {
          opacity: 0,
          duration: 0.5,
        },
        "1.5",
      );
      tl.to(
        articleContent,
        {
          y: 0,
          duration: 0.5,
        },
        "1.4",
      );
    });
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // check for project detail page on load - need to fade in bts button
  let projectPageCheck = document.querySelector(".projectpage");
  let btsBtnMobile = document.querySelector(".bts_mobile_btn");
  if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
    gsap.to(btsBtnMobile, {
      opacity: 1,
      duration: 0.5,
      delay: 1,
    });
  }

  // need to detect two_col_text tables and wrap all content in TD elements with .contents element

  function tableInit() {
    let twoColTextTables = document.querySelectorAll(".two_col_text table");
    twoColTextTables.forEach((table) => {
      let cells = table.querySelectorAll("td");
      cells.forEach((cell) => {
        let cellContent = cell.innerHTML.replace(/\s|&nbsp;/gi, "");
        let isEmpty = cellContent === "";
        let contents = document.createElement("div");
        contents.classList.add("contents");
        if (isEmpty) {
          contents.classList.add("blank");
        }
        while (cell.firstChild) {
          contents.appendChild(cell.firstChild);
        }
        cell.appendChild(contents);
      });
    });
  }

  tableInit();

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function footerCarouselInit() {
    let footerCarouselEl = document.querySelector(".slideshow_strip");
    let tickerSpeed = -0.6; // Adjust this value to change the speed of the ticker (negative for left, positive for right)
    let isPaused = false;
    let flktyLogos;

    const update = () => {
      if (isPaused) return;
      if (flktyLogos.slides) {
        flktyLogos.x = (flktyLogos.x + tickerSpeed) % flktyLogos.slideableWidth;
        //flktyLogos.x = flktyLogos.x * -1;

        flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
        flktyLogos.updateSelectedSlide();
        flktyLogos.settle(flktyLogos.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flktyLogos = new Flickity(footerCarouselEl, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
    flktyLogos.x = 0;

    update();
  }

  let footerCarouselEl = document.querySelector(".slideshow_strip");
  if (typeof footerCarouselEl != "undefined" && footerCarouselEl != null) {
    footerCarouselInit();
  }

  function loadInit() {
    // global animation effects
    ScrollTrigger.batch(".fadeUp", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });

    ScrollTrigger.batch(".fadeOn", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, stagger: 0.1 });
      },
    });

    setTimeout(function () {
      ScrollTrigger.batch(".fadeUpDelay", {
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
        },
      });
    }, 300);

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  loadInit();

  // loose grids

  let looseGrids = document.querySelectorAll(".grid_loose");
  looseGrids.forEach((looseGrid) => {
    let catid = looseGrid.getAttribute("data-catid");
    let grid;
    let view = "desktop";
    let resizeTimeout;

    function checkView() {
      let newView = innerWidth <= 768 ? "mobile" : "desktop";
      if (view !== newView) {
        view = newView;
        return true;
      }
      return false;
    }

    function loadGrid() {
      fetch(`/getCanvas.php?catid=${catid}&view=${view}`)
        .then((response) => response.text())
        .then((data) => {
          looseGrid.innerHTML = data;
          grid = looseGrid.querySelector("ul.canvas");

          const resizeObserver = new ResizeObserver(updatePositions);
          resizeObserver.observe(grid);

          loadInit();

          setTimeout(function () {
            updateContainerHeight();
          }, 500);
        })
        .catch((error) => console.error("Error:", error));
    }

    // Initial check and load
    checkView();
    loadGrid();

    // Debounced window resize handler
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (checkView()) {
          loadGrid();
        }
      }, 250); // Wait 250ms after last resize event
    });

    function updatePositions() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      const { width, height } = grid.getBoundingClientRect();

      items.forEach((item) => {
        let percentX = parseFloat(item.dataset.x);
        let percentY = parseFloat(item.dataset.y);

        // apply the new positions as pixels
        item.style.left = `${(percentX / 100) * width}px`;
        item.style.top = `${(percentY / 100) * width}px`; // Base top on width

        // clear out transforms from draggable
        gsap.set(item, {
          x: 0,
          y: 0,
          z: 0,
        });
      });

      updateContainerHeight();
    }

    function updateContainerHeight() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      requestAnimationFrame(() => {
        let maxBottom = 0;

        items.forEach((item) => {
          let topPos = gsap.getProperty(item, "top"); // Get the top position in pixels
          itemBottom = topPos + item.offsetHeight; // Distance from top + height
          maxBottom = Math.max(maxBottom, itemBottom);
        });

        grid.style.height = `${Math.ceil(maxBottom)}px`; // Round up & add buffer for admin, on front-end this should be tight to the grid
        grid.style.minHeight = "auto";
      });
    }
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    // fallback to desktop source if mobile source is not provided
    if (mobileSrc === "") {
      mobileSrc = desktopSrc;
    }

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      if (videoEl.classList.contains("sizeload")) {
        sizeloadVideo(videoEl, "yes");
      }
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // main page work filter

  function workFilterInit() {
    let workFilterEls = document.querySelectorAll(".navigation .page_filter");
    if (!workFilterEls.length) {
      return;
    }
    let pageTitleEl = document.querySelector(".navigation h1");
    let gridEl = document.querySelector(".grid");

    workFilterEls.forEach((workFilterEl) => {
      let filterType = workFilterEl.getAttribute("data-type") || "category";
      let filterItems = workFilterEl.querySelectorAll(".filter li");
      let filterLabel = workFilterEl.querySelector(".label span");

      filterItems.forEach((filterItem) => {
        filterItem.addEventListener("click", function (e) {
          e.preventDefault();
          let filterId = filterItem.getAttribute("data-id");
          let filterName = filterItem.getAttribute("data-name");

          // update the filter label with the selected item
          filterLabel.innerHTML = filterName;

          // remove the "hidden" class from all filter items and add it to the selected item
          filterItems.forEach((item) => {
            item.classList.remove("hidden");
          });
          filterItem.classList.add("hidden");

          // update the page title next element, apply the transform.
          pageTitleEl.querySelector(".next").innerHTML = filterName;
          pageTitleEl.classList.add("transition");

          // after the animation, reset the page title for another change
          setTimeout(function () {
            pageTitleEl.querySelector(".active").innerHTML = filterName;
            pageTitleEl.classList.remove("transition");
          }, 500);

          // ux changes are done, now get new grid content via ajax

          let newGridData = null;

          // get new content right away, while the page title is animating out, then fade in when ready
          getAjax(
            "/getGrid.php?catid=" + filterId + "&type=" + filterType,
            function (data) {
              newGridData = data;
            },
          );

          gsap.to(gridEl, {
            opacity: 0,
            duration: 0.3,
            ease: "power1.out",
            onComplete: function () {
              if (newGridData !== null) {
                gridEl.innerHTML = newGridData;
                gsap.to(gridEl, {
                  opacity: 1,
                  duration: 0.5,
                  ease: "power1.in",
                });
                loadInit();
              } else {
                // If AJAX hasn't completed yet, poll until it does
                const waitForData = setInterval(() => {
                  if (newGridData !== null) {
                    clearInterval(waitForData);
                    gridEl.innerHTML = newGridData;
                    gsap.to(gridEl, {
                      opacity: 1,
                      duration: 0.5,
                      ease: "power1.in",
                    });
                    loadInit();
                  }
                }, 50);
              }
            },
          });
        });
      });
    });
  }

  let workFilterEl = document.querySelector(".navigation .page_filter");
  if (typeof workFilterEl != "undefined" && workFilterEl != null) {
    workFilterInit();
  }

  // bts detail page

  let btsEl = document.querySelector(".bts");
  if (typeof btsEl != "undefined" && btsEl != null) {
    let btsTrigger = btsEl.querySelector(".border");
    let btsMobileTrigger = document.querySelector(".bts_mobile_btn");
    let btsClose = btsEl.querySelector(".close");
    [btsTrigger, btsMobileTrigger].forEach((trigger) => {
      if (trigger) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          btsEl.classList.toggle("active");

          if (!btsEl.classList.contains("active")) {
            btsEl.classList.add("close");
            btsMobileTrigger.innerHTML = "BTS";
            setTimeout(function () {
              btsEl.classList.remove("close");
            }, 520);
          } else {
            btsMobileTrigger.innerHTML = "CLOSE";
          }
        });
      }
    });
    btsClose.addEventListener("click", function (e) {
      e.preventDefault();
      btsEl.classList.remove("active");
      btsEl.classList.add("close");

      setTimeout(function () {
        btsEl.classList.remove("close");
      }, 520);
    });
  }

  // play icon click - inject video into vidhold
  document.addEventListener("click", function (e) {
    let playIcon = e.target.closest(".play_icon");
    if (!playIcon) return;
    e.preventDefault();
    let cell = playIcon.closest(".cell");
    let videoStr = cell.getAttribute("data-video");
    let vidhold = cell.querySelector(".vidhold");
    vidhold.innerHTML = videoStr;
    let video = vidhold.querySelector("video");
    if (video.classList.contains("sizeload")) {
      sizeloadVideo(video, "no");
    }
    cell.classList.add("fullvideo_playing");
  });

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
      });
    });
  });

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        (event.preventDefault(), document.body.classList.toggle("menuOn"));
      },
      true,
    );
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );
  }

  // start push state functions

  // Handle browser back/forward buttons
  window.addEventListener("popstate", async (event) => {
    const url = window.location.pathname;
    // Skip if only the hash changed (anchor link)
    if (window.location.hash) return;
    await loadContent(url);
  });

  const pageCache = new Map();
  const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes in milliseconds

  function pushStateInit() {
    // top level pages
    let pushStateLinks = document.querySelectorAll(".pushstate");
    if (typeof pushStateLinks != "undefined" && pushStateLinks != null) {
      pushStateLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          let url = link.getAttribute("href");
          loadContent(url);
          closeOverlay();
        });
      });
    }
  }

  pushStateInit();

  async function loadContent(url) {
    // Prevent loading if already in progress
    if (loadContent.isLoading) return;
    loadContent.isLoading = true;

    try {
      const parentEl = document.querySelector("section#content");

      // resets
      gsap.set(document.querySelector("footer"), { opacity: 0 });

      const btsBtnMobile = document.querySelector(".bts_mobile_btn");
      const navLinks = document.querySelectorAll("nav a");
      navLinks.forEach((link) => {
        link.classList.remove("pageOn");
      });
      const activeLink = document.querySelector(`nav a[href='${url}']`);
      if (activeLink) {
        activeLink.classList.add("pageOn");
      }

      const btsEl = document.querySelector(".bts");
      if (typeof btsEl != "undefined" && btsEl != null) {
        btsEl.classList.remove("showing");
      }

      // Start loading content immediately
      const [content] = await Promise.all([
        (async () => {
          const cached = pageCache.get(url);
          const now = Date.now();
          if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) {
            return Promise.resolve(cached.content);
          }
          const response = await fetch(`/content.php?page=${url}`);
          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
          const text = await response.text();
          pageCache.set(url, { content: text, timestamp: now });
          return text;
        })(),
        gsap
          .to(parentEl, {
            opacity: 0,
            duration: 0.3,
            ease: "power1.out",
          })
          .then(),
      ]);

      body.classList.remove("projectpage", "homepage", "playIntro", "passwordpage");

      // Update content and fade in
      parentEl.innerHTML = content;
      gsap.set(parentEl, { y: 150 });

      // general functions
      setTimeout(function () {
        tableInit();
        loadInit();
        pushStateInit();
        workFilterInit();
      }, 200);

      // colect page specific vars
      let newContentEl = parentEl.querySelector("article.inner");
      let newBodyClass = newContentEl.getAttribute("data-bodyclass");

      if (newBodyClass != "") {
        body.classList.add(...newBodyClass.split(" ")); // Add new classes while keeping existing ones
      }

      // page specific functions
      let arRowsEl = newContentEl.querySelector(".ar-rows");
      if (typeof arRowsEl != "undefined" && arRowsEl != null) {
        let arRowsEls = newContentEl.querySelectorAll(".ar-rows");
        setTimeout(function () {
          arRows(arRowsEls);
        }, 1000);
      }

      let masonGrids = newContentEl.querySelector(".masongrid");
      if (typeof masonGrids != "undefined" && masonGrids != null) {
        masonryInit();
      }

      let marqueeCheck = newContentEl.querySelector(".marquee .carousel");
      if (typeof marqueeCheck != "undefined" && marqueeCheck != null) {
        marqueeInits();
      }

      let projectPageCheck = parentEl.querySelector(".project_detail_page");
      if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
        btsEl.classList.add("showing");
        gsap.to(btsBtnMobile, {
          opacity: 1,
          duration: 0.5,
          delay: 1,
        });
        getAjax("/getBts.php?page=" + url, function (data) {
          let btsElInner = btsEl.querySelector(".contents");
          if (typeof btsElInner != "undefined" && btsElInner != null) {
            btsElInner.innerHTML = data;
            loadInit();
            arRowsEl = btsEl.querySelector(".ar-rows");
            if (typeof arRowsEl != "undefined" && arRowsEl != null) {
              let arRowsEls = btsEl.querySelectorAll(".ar-rows");
              arRows(arRowsEls);
            }
          }
        });
      } else {
        gsap.to(btsBtnMobile, {
          opacity: 0,
          duration: 0.3,
        });
      }

      gsap.to(parentEl, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        delay: 0.5,
      });

      // Update history
      history.pushState(null, null, url);

      // scroll to top of page
      setTimeout(function () {
        window.scrollTo(0, 0);
        gsap.to(document.querySelector("footer"), {
          opacity: 1,
          duration: 0.2,
        });
      }, 100);

      return content;
    } catch (error) {
      console.error("Failed to load content:", error);
      // Fade back in if there's an error
      const parentEl = document.querySelector("section#content");
      gsap.to(parentEl, { opacity: 1, y: 0, duration: 0.5 });
    } finally {
      loadContent.isLoading = false;
    }
  }
});
